export function toLowerCase(inputData) {
    if(!inputData) return '';
    return inputData.toLowerCase();
}